import type { IconProps } from '../types/IconProps.ts';
export const Folder: IconProps = {
    name: 'Folder',
    children: [
        `<path d="M3 7c0-1.1.9-2 2-2h2.4a2 2 0 0 1 1.6.8l1.05 1.4a2 2 0 0 0 1.6.8H19a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />`,
    ]
};